import React from 'react';
import { Container } from './styles';

const Input = ({
  onChange,
  onBlur,
  value,
  title,
  titlePosition,
  placeholder,
  additionalstyle,
  required,
  name,
  type,
  maxLength,
  defaultValue,
  inputFieldRef,
  mainPage,
  disabled,
  hidden,
  autoComplete,
  error,
  errorMessage
}) => {
  return (
    <Container
      additionalstyle={additionalstyle}
      mainPage={mainPage}
      error={error}
      disabled={disabled}
      hidden={hidden}
      titlePosition={titlePosition}
    >
      {title && <div className='label'>
        {title}
        {required? <span className='warning'> *</span>: null}
      </div>}
      <input
        disabled={disabled}
        className='input'
        name={name}
        type={type}
        maxLength={maxLength}
        value={value}
        autoComplete={autoComplete}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        defaultValue={defaultValue}
        ref={inputFieldRef}
      />
      {error? <div className="warning">{errorMessage?.length? errorMessage: 'This is a required field.'}</div>: null}
    </Container>
  );
}

export default Input;